import React from 'react';
import { translate } from '../../Services/translation';

const MeasuredWallpaperCutoutArrows = ({
  wallWidth,
  wallHeight,
}: {
  wallWidth: number;
  wallHeight: number;
}) => {
  return (
    <>
      {/* Width */}
      <div className="min-h-4 pointer-events-none absolute -top-8 z-40 flex h-4 w-full select-none flex-col items-center justify-center">
        <p className="absolute z-10 m-0 rounded bg-white px-1.5 py-1 text-center text-md font-medium lg:text-sm">
          {translate('general.width')} {wallWidth} cm
        </p>
        <div className="relative hidden w-full translate-y-3 transform items-center justify-between opacity-70 sm:translate-y-0 md:flex">
          <div className="rotate-180 transform">
            <svg
              height="14"
              width="8"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M.185.176a.655.655 0 01.893 0l6.737 6.4a.579.579 0 010 .848l-6.737 6.4a.655.655 0 01-.893 0 .58.58 0 010-.848L6.475 7 .185 1.024a.579.579 0 010-.848z"
                fill="#333"
              />
            </svg>
          </div>
          <div className="absolute left-0 right-0 top-1/2 flex h-px w-full -translate-y-1/2 transform bg-gray-900"></div>
          <svg
            height="14"
            width="8"
            viewBox="0 0 8 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M.185.176a.655.655 0 01.893 0l6.737 6.4a.579.579 0 010 .848l-6.737 6.4a.655.655 0 01-.893 0 .58.58 0 010-.848L6.475 7 .185 1.024a.579.579 0 010-.848z"
              fill="#333"
            />
          </svg>
        </div>
      </div>
      {/* Height */}
      <div className="pointer-events-none absolute -left-8 top-1/2 z-40 flex h-full w-4 -translate-y-1/2 transform select-none flex-col items-center justify-center">
        <p className="absolute z-10 m-0 -rotate-90 whitespace-nowrap rounded bg-white px-1 py-1.5 text-center text-md font-medium lg:text-sm">
          {translate('general.height')} {wallHeight} {'cm'}
        </p>
        <div className="relative bottom-0 top-0 hidden h-full translate-x-3 transform flex-col justify-between opacity-70 sm:translate-x-0 md:flex">
          <div className="-translate-y-1 -rotate-90 transform">
            <svg
              height="14"
              width="8"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M.185.176a.655.655 0 01.893 0l6.737 6.4a.579.579 0 010 .848l-6.737 6.4a.655.655 0 01-.893 0 .58.58 0 010-.848L6.475 7 .185 1.024a.579.579 0 010-.848z"
                fill="#333"
              />
            </svg>
          </div>
          <div className="absolute bottom-0 left-1/2 top-0 flex h-full w-px -translate-x-1/2 transform bg-gray-900"></div>
          <div className="translate-y-1 rotate-90 transform">
            <svg
              height="14"
              width="8"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M.185.176a.655.655 0 01.893 0l6.737 6.4a.579.579 0 010 .848l-6.737 6.4a.655.655 0 01-.893 0 .58.58 0 010-.848L6.475 7 .185 1.024a.579.579 0 010-.848z"
                fill="#333"
              />
            </svg>
          </div>
        </div>
      </div>
    </>
  );
};

export default MeasuredWallpaperCutoutArrows;
